<template>
  <div class="card card-custom">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">Conciliação Financeira (ECONF)</h3>
      </div>
    </div>
    <div class="card-body">
      <p>
        Habilite o ECONF por UF para registrar pagamentos nas ações de NF-e e
        NFC-e. O envio é feito manualmente pelo usuário.
      </p>
      <b-alert :show="!!erro" variant="danger" role="alert">{{ erro }}</b-alert>
      <b-alert :show="!!sucesso" variant="success" role="status">{{
        sucesso
      }}</b-alert>
      <div v-if="carregando" class="text-center p-4">
        <b-spinner label="Carregando configurações" />
      </div>
      <b-button v-else-if="falha" variant="outline-primary" @click="carregar"
        >Tentar novamente</b-button
      >
      <EconfConfiguracaoForm
        v-else
        :configuracao="configuracao"
        :ocupado="salvando"
        @mudar-uf="selecionarUf"
        @salvar="salvar"
        @cancelar="$router.push({ name: 'configuracoesLista' })"
      />
      <div v-if="falha" class="mt-5">
        <router-link :to="{ name: 'configuracoesLista' }"
          >Voltar às configurações fiscais</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import EconfConfiguracaoForm from "@/modules/NFe/components/EconfConfiguracaoForm.vue";
import { configuracaoPadrao, erroEconf } from "@/modules/NFe/services/econf";
export default {
  name: "EconfConfiguracoes",
  components: { EconfConfiguracaoForm },
  data() {
    return {
      carregando: false,
      salvando: false,
      falha: false,
      erro: "",
      sucesso: "",
      configuracoes: [],
      configuracao: configuracaoPadrao(),
      versao: 0,
    };
  },
  computed: {
    empresaId() {
      return (
        this.$store?.getters?.empresaContexto?.id_empresa ||
        this.$store?.getters?.currentUser?.usuario_empresa?.id_empresa ||
        null
      );
    },
  },
  watch: {
    empresaId() {
      this.salvando = false;
      this.configuracoes = [];
      this.configuracao = configuracaoPadrao();
      this.carregar();
    },
  },
  created() {
    this.carregar();
  },
  beforeDestroy() {
    this.versao++;
  },
  methods: {
    async carregar() {
      const versao = ++this.versao;
      this.carregando = true;
      this.falha = false;
      this.erro = "";
      this.sucesso = "";
      try {
        const { data } = await this.$http.get("/nfe/econf/configuracoes");
        if (versao !== this.versao) return;
        this.configuracoes = data;
        this.selecionarUf(this.configuracao.uf || data[0]?.uf || "");
      } catch (erro) {
        if (versao === this.versao) {
          this.erro = erroEconf(erro);
          this.falha = true;
        }
      } finally {
        if (versao === this.versao) this.carregando = false;
      }
    },
    selecionarUf(uf) {
      this.configuracao =
        this.configuracoes.find((item) => item.uf === uf) ||
        configuracaoPadrao(uf);
      this.sucesso = "";
    },
    async salvar(dados) {
      if (this.salvando) return;
      const versao = this.versao;
      this.salvando = true;
      this.erro = "";
      this.sucesso = "";
      try {
        const { data } = await this.$http.put(
          "/nfe/econf/configuracoes",
          dados
        );
        if (versao !== this.versao) return;
        this.configuracoes = [
          ...this.configuracoes.filter((item) => item.uf !== data.uf),
          data,
        ];
        this.configuracao = data;
        this.sucesso = "Configuração do ECONF salva para " + data.uf + ".";
      } catch (erro) {
        if (versao === this.versao) this.erro = erroEconf(erro);
      } finally {
        if (versao === this.versao) this.salvando = false;
      }
    },
  },
};
</script>
